import React from 'react';

const LastTransaction = ({ carDetails = {}, transactionTypes = [], lastPayment = null, lastPaymentLoading = false, formatDate = (d) => d, formatMoney = (v) => v }) => {
    const typeObj = transactionTypes.find(t => t.value === (carDetails.last_trans_type || ''));
    const typeLabel = typeObj ? typeObj.label : carDetails.last_trans_type || 'N/A';

    return (
        <div className="bg-gray-50 rounded-sm border border-gray-200 p-3">
            <h3 className="text-xs font-bold text-[#2a2e30] mb-2.5 flex items-center">
                <div className="w-2 h-2 bg-[#FF5733] rounded-full mr-2"></div>
                Last Transaction
            </h3>
            <div className="space-y-2 text-xs">
                <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                    <span className="text-gray-700 font-medium">Date:</span>
                    <span className="font-medium text-[#2a2e30] text-xs xl:text-right">{formatDate(carDetails.last_trans_date)}</span>
                </div>
                <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                    <span className="text-gray-700 font-medium">Type:</span>
                    <span className="font-medium text-[#2a2e30] text-xs xl:text-right">{typeLabel}</span>
                </div>
                <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                    <span className="text-gray-700 font-medium">Doc No:</span>
                    <span className="font-mono font-medium text-xs text-[#2a2e30] xl:text-right">{carDetails.last_trans_doc_no || 'N/A'}</span>
                </div>
                <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                    <span className="text-gray-700 font-medium">Reference:</span>
                    <span className="font-mono font-medium text-xs text-[#2a2e30] xl:text-right">{carDetails.last_trans_your_ref || 'N/A'}</span>
                </div>
                <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                    <span className="text-gray-700 font-medium">By:</span>
                    <span className="font-medium text-[#2a2e30] text-xs xl:text-right">{carDetails.last_trans_by || 'N/A'}</span>
                </div>

                {lastPaymentLoading ? (
                    <div className="border-t border-gray-300 pt-2.5 mt-2.5">
                        <div className="text-center py-1">Loading payment...</div>
                    </div>
                ) : lastPayment ? (
                    <>
                        <div className="border-t border-gray-300 pt-2.5 mt-2.5">
                            <div className="text-xs font-semibold text-gray-500 mb-2">Last Payment (WAR)</div>
                        </div>
                        <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                            <span className="text-gray-700 font-medium">Payment Date:</span>
                            <span className="font-medium text-[#2a2e30] text-xs xl:text-right">{formatDate(lastPayment.date)}</span>
                        </div>
                        <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                            <span className="text-gray-700 font-medium">Payment Amount:</span>
                            <span className="font-medium text-green-600 text-xs xl:text-right">{formatMoney(lastPayment.amount)}</span>
                        </div>
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default LastTransaction;
